import { Injectable } from '@angular/core';

export const getTableSettingKey = (key: SessionStorageKey, value: string) => key.replace('{table-type}', value);
@Injectable({
    providedIn: 'root'
})
export class SessionStorageService {
    public setItem(key: SessionStorageKey, value: unknown) {
        sessionStorage.setItem(key, JSON.stringify(value));
    }

    public removeItem(key: SessionStorageKey) {
        sessionStorage.removeItem(key);
    }

    public removeAll() {
        sessionStorage.clear();
    }

    public getItem<T>(key: SessionStorageKey): T | null {
        const data = sessionStorage.getItem(key);
        if (data == null) {
            return null;
        }
        return JSON.parse(data) as T | null;
    }

    public setObject<T>(key: string, value: T) {
        sessionStorage.setItem(key, JSON.stringify(value));
    }

    public getObject<T>(key: string, deserializeFunction?: (data: T) => T) {
        const data = sessionStorage.getItem(key);
        if (data == null) {
            return null;
        }
        return deserializeFunction ? deserializeFunction(JSON.parse(data) as T) : (JSON.parse(data) as T);
    }
}

export enum SessionStorageKey {
    User = 'user',
    Token = 'token',
    RefreshToken = 'refresh-token',
    TableFilter = 'table_filter_{table-type}',
    TableSort = 'table_sort_{table-type}',
    CachedPdfFile = 'cachedpdffile'
}
